export class DoctorSummaryResponseModel {
  crmDoctorId: number;
  crmDoctorFirstName: string;
  crmDoctorLastName: string;
  crmDoctorAddress: string;
  crmDoctorContactNo: string;
  crmDoctorContactEmailAddress: string;
}
